var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid", attrs: { id: "user-page" } },
    [
      _vm.isMessage
        ? _c(
            "div",
            {
              staticClass: "alert alert-danger alert-margin",
              attrs: { role: "alert" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _vm._e(),
      _c("div", { staticClass: "row", attrs: { id: "title" } }, [
        _c("div", { staticClass: "col-1" }, [
          _c(
            "svg",
            {
              staticClass: "bd-placeholder-img mr-2 rounded",
              attrs: {
                id: "header",
                width: "28",
                height: "28",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMidYMid slice",
                focusable: "false",
                role: "img",
                "aria-label": "Placeholder: 32x32",
              },
            },
            [
              _c("rect", {
                attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
              }),
            ]
          ),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "col-6 text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-outline-info",
              attrs: { type: "button" },
              on: { click: _vm.request },
            },
            [_vm._v("電波ログを取得する")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "row", attrs: { id: "main" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-9" }, [
          _c(
            "table",
            { staticClass: "table table-dark table-sm table-hover" },
            [
              _vm._m(1),
              _c(
                "tbody",
                _vm._l(_vm.logs, function (log, index) {
                  return _c("tr", { key: log.id }, [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(_vm._s(_vm.currentIndex * _vm.limit + index + 1)),
                    ]),
                    _c("td", [_vm._v(_vm._s(log.kind))]),
                    _c("td", [_vm._v(_vm._s(log.status))]),
                    _c("td", [_vm._v(_vm._s(log.fileName))]),
                    _c("td", [_vm._v(_vm._s(log.lastModified))]),
                    _c("td", [
                      log.status === "正常終了"
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-sm btn-light",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.download(log.fileName)
                                },
                              },
                            },
                            [_vm._v("ダウンロードする")]
                          )
                        : _vm._e(),
                    ]),
                  ])
                }),
                0
              ),
            ]
          ),
          _c("nav", { attrs: { "aria-label": "pager" } }, [
            _c("ul", { staticClass: "pagination justify-content-center" }, [
              _vm.isPrev
                ? _c("li", { on: { click: _vm.goPrev } }, [
                    _c("a", { staticClass: "btn page-link rounded-pill" }, [
                      _vm._v("← 前"),
                    ]),
                  ])
                : _vm._e(),
              _vm.isPrev || _vm.isNext
                ? _c("li", { staticClass: "mx-2" }, [
                    _c("a", { staticClass: "btn page-link rounded-pill" }, [
                      _vm._v("現在"),
                    ]),
                  ])
                : _vm._e(),
              _vm.isNext
                ? _c("li", { on: { click: _vm.goNext } }, [
                    _c("a", { staticClass: "btn page-link rounded-pill" }, [
                      _vm._v("次 →"),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "col-2" }),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-3" }, [
      _c("h5", [_vm._v("電波ログ一覧")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "70px" }, attrs: { scope: "col" } }, [
          _vm._v("#"),
        ]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("種別")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("ステータス")]),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("名称")]),
        _c("th", { staticStyle: { width: "200px" }, attrs: { scope: "col" } }, [
          _vm._v("更新日時"),
        ]),
        _c("th", { staticStyle: { width: "200px" }, attrs: { scope: "col" } }, [
          _vm._v("操作"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }